import React, { useEffect, useState } from "react";
import { Modal, Space, Button } from "antd";
import axios from "axios";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import PageContent from "../../components/layout/PageContent";
import { getTableState } from "../../utils/localStorage";
import { getFormattedResponse } from "../../utils";
import CustomTable from "../../components/table/CustomTable";

const tablePrefix = 'config_access_items';

const AccessItems = () => {

	const [ data, setData ] = useState([]);
	const [ columns, setColumns ] = useState([]);
	const [ tableState, setTableState ] = useState(() => {
        const {
            pageSize = 10,
            page = 1,
            loading = false,
            totalSize = 1
        } = getTableState(tablePrefix);
        return {
            pageSize,
            page,
            loading,
            totalSize,
        }
    });

	const confirm = Modal.confirm;

  	useEffect(() => {
		const { page, size } = tableState;
        fetchData({
            page,
            size
        });
        // Зөвхөн mount дээр эхний хуудсыг татна.
        // eslint-disable-next-line react-hooks/exhaustive-deps
  	}, []);

	const fetchData = (params) => {
		setData([]);
		setTableState((prevState) => ({ ...prevState, loading: true }));
		axios
			.post(
				"/api/1.0/accessitem/list",
				params,
			)
			.then(({ data }) => {
				const { 
					list, 
					columns: cols,
					rest: { totalDocs = 1, limit = 20 } = {},  
				} = getFormattedResponse(data);
				setColumns(cols);
				setData(list);
				setTableState((prevState) => {
					return {
						...prevState,
						totalSize: totalDocs,
						loading: false,
						pageSize: limit,
					}
				});
			})
			.catch((e) => {
				console.error('Fetch Access Items: ', e);
			})
			.finally(() => {
				setTableState((prevState) => ({ ...prevState, loading: false }));
			});
  	};

  	const handleInteraction = ({ page, pageSize, query, sort, order }) => {
		const params = {
			page, 
			size: pageSize,
			query,
			sort,
			order
		};
		setTableState({
			...tableState,
			page,
			pageSize,
			loading: true,
			sort,
			order
		})
		fetchData(params);
	};

	const deleteAccessItem = (id) => {
		return new Promise((resolve, reject) => {
			axios.delete(`/api/1.0/accessitem/${id}`)
			.then(({ data }) => {
				if (data.statusCode === 200) {
					fetchData(tableState);
				}
				resolve();
			})
			.catch(e => {
				reject();
				console.error('Delete Access Item: ', e);
			})
		})
	}

	const showConfirm = (_id) => {
		confirm({
			title: "Мэдээллийг устгах уу?",
			okText: "Устгах",
			cancelText: "Цуцлах",
			okType: 'danger',
			onOk() {
				// Promise буцаавал устгаж дуустал "Устгах" товч loading байна
				return deleteAccessItem(_id);
			},
		});
	};

	const getColumns = () => {
		const formattedColumns = columns.map(col => {
			let render;
            if (col.instance === 'boolean') {
                render = (text, record) => {
                    return record?.[col?.dataIndex] ? 'Тийм' : 'Үгүй';
                } 
            }
            return {
                ...col,
                render,
            }
		})

		const additionalColumns = [
			{
				key: "action",
				width: 1,
				sorter: false,
				render: (text, record) => (
					<Space size="middle" align="center">
						<Link 
							to={{
								pathname: '/accessitem/edit',
								state: {
									id: record._id
								},
							}}
						>
							<EditOutlined />
						</Link>
						<DeleteOutlined onClick={() => showConfirm(record._id)} />
					</Space>
				),
			},
		];

		return [
			...formattedColumns,
			...additionalColumns
		];
	};

	const getSubheaderContent = () => {
		return (
			<Link to={`/accessitem/add`}>
				<Button type='primary'>
					Шинэ хандах элемент үүсгэх
				</Button>
			</Link>
		)
	}

	return (
		<PageContent
			subheader={{
				title: 'Хандах элментүүд',
				background: '#ffffff',
				content: getSubheaderContent(),
			}}
		>
			<CustomTable
				bordered
				prefix={tablePrefix}
				dataSource={data}
				columns={getColumns()}
				rowKey='_id'
				showAll={false}
				onInteract={handleInteraction}
				state={tableState}
			/>
	  	</PageContent>
	)
};

export default AccessItems;